import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa6";
import MarketOverview3 from "./MarketOverview3";

function ReportType3() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <>
      <div className="bg-blue-50 p-4 sm:p-6 md:p-7 lg:pb-32">
        <MarketOverview3 />

        {isVisible && (
          <div
            onClick={scrollToTop}
            className="fixed bottom-4 right-4 sm:bottom-10 sm:right-5 cursor-pointer bg-gray-300 hover:bg-gray-400 rounded-full p-2 sm:p-4 transition-colors duration-300"
          >
            <FaArrowUp className="text-xl sm:text-2xl" />
          </div>
        )}
      </div>
    </>
  );
}

export default ReportType3;
